import React from "react";
import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@mui/material";
import { useIntl } from "react-intl";

export default function AlertDialog({
  buttonTitle = "Open alert dialog",
  alertTitle = null,
  alertBody = "¿Estás seguro de eliminar este torneo?",
  confirmButtonTitle = null,
  cancelButtonTitle = null,
  isOpen = false,
  hideButton = false,
  onConfirm = () => {},
  onCancel = () => {},
}) {
  const intl = useIntl();
  const [open, setOpen] = React.useState(false);
  const confirmLabel = confirmButtonTitle ?? intl.formatMessage({ id: "common.confirm" });
  const cancelLabel = cancelButtonTitle ?? intl.formatMessage({ id: "Cancelar" });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (confirm) => {
    setOpen(false);
    if (confirm) {
      onConfirm();
    } else {
      onCancel();
    }
  };

  return (
    <div>
      {!hideButton && (
        <Button variant="outlined" color="primary" onClick={handleClickOpen}>
          {buttonTitle}
        </Button>
      )}
      <Dialog
        open={hideButton ? isOpen : open}
        onClose={() => handleClose(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {alertTitle && <DialogTitle id="alert-dialog-title">{alertTitle}</DialogTitle>}
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{alertBody}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose(false)} color="text.secondary">
            {cancelLabel}
          </Button>
          <Button variant="contained" onClick={() => handleClose(true)} color="primary" autoFocus>
            {confirmLabel}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
